export const investOptions = [
    {
        value: null,
        text: '',
        operator: null,
    },
    {
        value: 2.5,
        text: 'Менее 2.5',
        operator: 'LT',
    },
    {
        value: 2.5,
        text: 'От 2.5',
        operator: 'GE',
    },
    {
        value: 20,
        text: 'От 20',
        operator: 'GE',
    },
    {
        value: 30,
        text: 'От 30',
        operator: 'GE',
    },
    {
        value: 50,
        text: 'От 50',
        operator: 'GE',
    },
    {
        value: 100,
        text: 'От 100',
        operator: 'GE',
    },
    {
        value: 120,
        text: 'От 120',
        operator: 'GE',
    },
    {
        value: 150,
        text: 'От 150',
        operator: 'GE',
    },
    {
        value: 250,
        text: 'От 250',
        operator: 'GE',
    },
    {
        value: 300,
        text: 'От 300',
        operator: 'GE',
    },
    {
        value: 500,
        text: 'От 500',
        operator: 'GE',
    },
    {
        value: 1000,
        text: 'От 1 млрд',
        operator: 'GE',
    },
    {
        value: 1500,
        text: 'От 1.5 млрд',
        operator: 'GE',
    },
    {
        value: 5000,
        text: 'От 5 млрд',
        operator: 'GE',
    },
];

export const workplaceOptions = [
    {
        value: null,
        text: '',
        operator: null,
    },
    {
        value: 10,
        text: 'Менее 10',
        operator: 'LT',
    },
    {
        value: 10,
        text: 'От 10',
        operator: 'GE',
    },
    {
        value: 20,
        text: 'От 20',
        operator: 'GE',
    },
    {
        value: 30,
        text: 'От 30',
        operator: 'GE',
    },
    {
        value: 50,
        text: 'От 50',
        operator: 'GE',
    },
    {
        value: 70,
        text: 'От 70',
        operator: 'GE',
    },
    {
        value: 100,
        text: 'От 100',
        operator: 'GE',
    },
    {
        value: 120,
        text: 'От 120',
        operator: 'GE',
    },
    {
        value: 150,
        text: 'От 150',
        operator: 'GE',
    },
    {
        value: 200,
        text: 'От 200',
        operator: 'GE',
    },
    {
        value: 250,
        text: 'От 250',
        operator: 'GE',
    },
    {
        value: 300,
        text: 'От 300',
        operator: 'GE',
    },
    {
        value: 400,
        text: 'От 400',
        operator: 'GE',
    },
    {
        value: 500,
        text: 'От 500',
        operator: 'GE',
    },
];

export const startYearOptions = [
    {
        value: null,
        text: '',
        operator: null,
    },
    {
        value: 2017,
        text: 'До 2017',
        operator: 'LT',
    },
    {
        value: 2017,
        text: 'От 2017',
        operator: 'GE',
    },
    {
        value: 2018,
        text: 'От 2018',
        operator: 'GE',
    },
    {
        value: 2019,
        text: 'От 2019',
        operator: 'GE',
    },
    {
        value: 2020,
        text: 'От 2020',
        operator: 'GE',
    },
    {
        value: 2021,
        text: 'От 2021',
        operator: 'GE',
    },
    {
        value: 2022,
        text: 'От 2022',
        operator: 'GE',
    },
    {
        value: 2023,
        text: 'От 2023',
        operator: 'GE',
    },
    {
        value: 2024,
        text: 'От 2024',
        operator: 'GE',
    },
    {
        value: 2025,
        text: 'От 2025',
        operator: 'GE',
    },
    {
        value: 2026,
        text: 'От 2026',
        operator: 'GE',
    },
    {
        value: 2027,
        text: 'От 2027',
        operator: 'GE',
    },
    {
        value: 2028,
        text: 'От 2028',
        operator: 'GE',
    },
    {
        value: 2029,
        text: 'От 2029',
        operator: 'GE',
    },
];

export const paybackYearOptions = [
    {
        value: null,
        text: '',
        operator: null,
    },
    {
        value: 1,
        text: 'До 1',
        operator: 'LT',
    },
    {
        value: 1,
        text: 'От 1',
        operator: 'GE',
    },
    {
        value: 2,
        text: 'От 2',
        operator: 'GE',
    },
    {
        value: 3,
        text: 'От 3',
        operator: 'GE',
    },
    {
        value: 4,
        text: 'От 4',
        operator: 'GE',
    },
    {
        value: 5,
        text: 'От 5',
        operator: 'GE',
    },
    {
        value: 6,
        text: 'От 6',
        operator: 'GE',
    },
    {
        value: 7,
        text: 'От 7',
        operator: 'GE',
    },
    {
        value: 8,
        text: 'От 8',
        operator: 'GE',
    },
    {
        value: 9,
        text: 'От 9',
        operator: 'GE',
    },
    {
        value: 10,
        text: 'От 10',
        operator: 'GE',
    },
    {
        value: 11,
        text: 'От 11',
        operator: 'GE',
    },
    {
        value: 12,
        text: 'От 12',
        operator: 'GE',
    },
    {
        value: 13,
        text: 'От 13',
        operator: 'GE',
    },
];

export const paybackPercentOptions = [
    {
        value: null,
        text: '',
        operator: null,
    },
    {
        value: 2.5,
        text: 'До 2.5',
        operator: 'LT',
    },
    {
        value: 2.5,
        text: 'От 2.5',
        operator: 'GE',
    },
    {
        value: 5,
        text: 'От 5',
        operator: 'GE',
    },
    {
        value: 7,
        text: 'От 7',
        operator: 'GE',
    },
    {
        value: 10,
        text: 'От 10',
        operator: 'GE',
    },
    {
        value: 13,
        text: 'От 13',
        operator: 'GE',
    },
    {
        value: 15,
        text: 'От 15',
        operator: 'GE',
    },
    {
        value: 18,
        text: 'От 18',
        operator: 'GE',
    },
    {
        value: 20,
        text: 'От 20',
        operator: 'GE',
    },
    {
        value: 25,
        text: 'От 25',
        operator: 'GE',
    },
    {
        value: 30,
        text: 'От 30',
        operator: 'GE',
    },
    {
        value: 35,
        text: 'От 35',
        operator: 'GE',
    },
    {
        value: 40,
        text: 'От 40',
        operator: 'GE',
    },
    {
        value: 50,
        text: 'От 50',
        operator: 'GE',
    },
];